import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CoverIsFor } from '../types/types';
import { Progress } from '@mantine/core';

function MobileProgressBar() {
  const { formData, currentStep } = useSelector(
    (state: any) => state.formRegistration,
  );
  const totalSteps = useMemo(() => {
    return [CoverIsFor.Family, CoverIsFor.SingleParentFamily].includes(
      formData.coverIsFor,
    )
      ? 8
      : 7;
  }, [formData.coverIsFor]);
  const getCurrentStep = () => {
    if (
      CoverIsFor.SingleParentFamily === formData.coverIsFor ||
      CoverIsFor.Family === formData.coverIsFor
    ) {
      switch (currentStep) {
        case 0:
          return 1;
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 5;
        case 5:
          return 6;
        case 6:
          return 6;
        case 7:
          return 7;
        case 8:
          return 8;
        default:
          return 0;
      }
    } else {
      switch (currentStep) {
        case 0:
          return 1;
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 4;
        case 5:
          return 6;
        case 6:
          return 5;
        case 7:
          return 6;

        case 8:
          return 7;
        default:
          return 0;
      }
    }
  };
  const { isMobileView } = useSelector((state: any) => state.viewport);

  if (isMobileView) {
    <>
      <Progress
        value={(getCurrentStep() / totalSteps) * 100}
        classNames={{
          section: 'bg-[#C72A16] rounded-r-[5px] rounded-l-[0px] h-[5px]',
          root: 'bg-[#D1D7DF] rounded-l-[0px] h-[5px] flex w-full',
        }}
      />
      <div className="p-[15px] w-full bg-[white] flex flex-col">
        <span className="text-[#CD232E] text-[12px] text-start">
          Step {getCurrentStep()} of{' '}
          {[CoverIsFor.SingleParentFamily, CoverIsFor.Family].includes(
            formData.coverIsFor,
          )
            ? 8
            : 7}
        </span>
      </div>
    </>;
  }
  return (
    <>
      <Progress
        value={(getCurrentStep() / totalSteps) * 100}
        classNames={{
          section: 'bg-[#C72A16] rounded-r-[5px] rounded-l-[0px] h-[5px]',
          root: 'bg-[#D1D7DF] rounded-l-[0px] h-[5px] flex w-full',
        }}
      />
    </>
  );
}

export default MobileProgressBar;
